<app-hero-banner
  [title]="'about us'"
  [isFullBanner]="false"
  [imgPath]="imgPath"
></app-hero-banner>
<div class="container">
  <div class="inspired">
    <div>
      <p>
        Inspired by my Grandfather, Bourne Bespoke was founded on a deep passion
        for craftsmanship and innovative engineering with an extensive
        background in creative design & build management. A desire to be
        different lies at the heart of every new design brief - devoting the
        time to fully understand my client's core requirements and intended
        material finish.
      </p>
      <br />
      <p>
        Translating these into a 3D rendered CAD model encourages more effective
        collaboration to ensure the end result exceeds your expectations. This
        design development technique helps to assess all interface and
        structural factors to take maximum advantage of the space.
      </p>
      <br />
      <p>
        I thoroughly enjoy turning constraints into unseen opportunities with a
        refined level of attention to detail. Whatever the desire or challenge -
        Bourne Bespoke will create something truly unique with the perfect
        balance of form and function. This is Creative Home Enhancement.
      </p>
    </div>

    <img src="../../assets/hi-res/about-pic.png" alt="Inspiration" />
  </div>

  <div class="definition">
    <div class="text">
      <h2>DeWalt&#174; brand ambassador</h2>
      <p>
        As proud ambassadors for DeWalt, our team works with industry-leading
        tools that ensure precision, durability, and an exceptional finish. This
        partnership allows us to bring the highest standards of craftsmanship to
        every project, ensuring that each creation reflects both our dedication
        and DeWalt’s cutting-edge innovation.
      </p>
    </div>

    <img src="../../assets/hi-res/mikey.jpg" alt="Inspiration" />
  </div>
</div>
